export interface MockBGGGame {
  id: string
  name: string
  year_published: number
  image_url: string
  thumbnail_url: string
  min_players: number
  max_players: number
  min_playtime: number
  max_playtime: number
  complexity: number // weight
  bgg_rank: number
  recommended_age: number
}

export const mockBGGGames: MockBGGGame[] = [
  {
    id: 'bgg-174430',
    name: 'Gloomhaven',
    year_published: 2017,
    image_url: 'https://cf.geekdo-images.com/sZYp_3BTDGjh2unaZfZmuA__original/img/7d-lj5Gd1e8PFnD97LYFah2c45M=/0x0/filters:format(jpeg)/pic2437871.jpg',
    thumbnail_url: 'https://cf.geekdo-images.com/sZYp_3BTDGjh2unaZfZmuA__thumb/img/veqFeP4d_3zNhFc3GNBkV95rBEQ=/fit-in/200x150/filters:strip_icc()/pic2437871.jpg',
    min_players: 1,
    max_players: 4,
    min_playtime: 60,
    max_playtime: 120,
    complexity: 3.88,
    bgg_rank: 1,
    recommended_age: 14
  },
  {
    id: 'bgg-291457',
    name: 'Brass: Birmingham',
    year_published: 2018,
    image_url: 'https://cf.geekdo-images.com/x3zxjr-Vw5iU4yDPg70Jgw__original/img/FpyxH41Y6_ROoePAilwLgdr_MYE=/0x0/filters:format(jpeg)/pic3490053.jpg',
    thumbnail_url: 'https://cf.geekdo-images.com/x3zxjr-Vw5iU4yDPg70Jgw__thumb/img/dWSlA96Osr2jDYXAHQwEsrHaJ8o=/fit-in/200x150/filters:strip_icc()/pic3490053.jpg',
    min_players: 2,
    max_players: 4,
    min_playtime: 60,
    max_playtime: 120,
    complexity: 3.9,
    bgg_rank: 3,
    recommended_age: 14
  },
  {
    id: 'bgg-167791',
    name: 'Terraforming Mars',
    year_published: 2016,
    image_url: 'https://cf.geekdo-images.com/wg9oOLcsKvDesSUdZQ4rxw__original/img/thIqWDnH9utKuoKVEUqveDixprI=/0x0/filters:format(jpeg)/pic3536616.jpg',
    thumbnail_url: 'https://cf.geekdo-images.com/wg9oOLcsKvDesSUdZQ4rxw__thumb/img/ZoQGTXPGWndDSVVVXPJT-1rSFB0=/fit-in/200x150/filters:strip_icc()/pic3536616.jpg',
    min_players: 1,
    max_players: 5,
    min_playtime: 120,
    max_playtime: 120,
    complexity: 3.24,
    bgg_rank: 4,
    recommended_age: 12
  },
  {
    id: 'bgg-224517',
    name: 'Wingspan',
    year_published: 2019,
    image_url: 'https://cf.geekdo-images.com/yLZJCVLlIx4c7eJEWUNJ7w__original/img/cI782Zis9cT66j2MjSHKJGnFPNw=/0x0/filters:format(jpeg)/pic4458123.jpg',
    thumbnail_url: 'https://cf.geekdo-images.com/yLZJCVLlIx4c7eJEWUNJ7w__thumb/img/VNToqgS2-pOGU6MuvIGMauLehmA=/fit-in/200x150/filters:strip_icc()/pic4458123.jpg',
    min_players: 1,
    max_players: 5,
    min_playtime: 40,
    max_playtime: 70,
    complexity: 2.4,
    bgg_rank: 22,
    recommended_age: 10
  },
  {
    id: 'bgg-342942',
    name: 'Ark Nova',
    year_published: 2021,
    image_url: 'https://cf.geekdo-images.com/SoU8p28Sk1s8MSvoM4N8pQ__original/img/g4T_KZ0jmIZ0xZHR2J8a5UpRmVs=/0x0/filters:format(jpeg)/pic6293412.jpg',
    thumbnail_url: 'https://cf.geekdo-images.com/SoU8p28Sk1s8MSvoM4N8pQ__thumb/img/aT0nFOrpJpwIzQvQCQ6VN1QLRPk=/fit-in/200x150/filters:strip_icc()/pic6293412.jpg',
    min_players: 1,
    max_players: 4,
    min_playtime: 90,
    max_playtime: 150,
    complexity: 3.9,
    bgg_rank: 5,
    recommended_age: 14
  }
]

// Mock data for user's library games (subset of the same games for simplicity)
export const mockLibraryGames = mockBGGGames.slice(0, 2)
